/**
 * @component MitarbeiterAvatar
 * @description Avatar-Anzeige fuer Mitarbeiter. Zeigt entweder das Profilbild
 * oder einen dezenten Initialen-Fallback (bg-inset + Border + Initialen).
 * Style wie in MitarbeiterPage (Referenz-Layout).
 *
 * @prop {string} [imageUrl]  - URL zum Profilbild (falls vorhanden)
 * @prop {string} [name]      - Name des Mitarbeiters (fuer Initialen-Fallback)
 * @prop {number} [size=28]   - Groesse in Pixeln (28, 32, 40, 56 empfohlen)
 * @prop {string} [className] - Optionale CSS-Klassen
 */
function initialsFromName(name = '') {
  const trimmed = String(name).trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  const a = parts[0]?.[0] || '';
  const b = parts.length > 1 ? parts[parts.length - 1]?.[0] || '' : '';
  return (a + b).toUpperCase().slice(0, 2) || '?';
}

export default function MitarbeiterAvatar({ imageUrl, name = '', size = 28, className = '' }) {
  const initials = initialsFromName(name);
  const fontSize = size <= 24 ? 9 : size <= 32 ? 10 : size <= 40 ? 12 : 14;

  // #1854 Punkt 3: `width`/`height` allein halten den Kreis nur dort rund, wo der
  // Elternteil nicht mitredet. `flex-shrink-0` schuetzt ausschliesslich Flex-Kinder —
  // in einer Tabellenzelle oder einem Grid darf der Kasten trotzdem schmaler werden,
  // und dann wird aus dem Portraet-Foto ein senkrechter Streifen. `minWidth`/
  // `minHeight` sind die Zusage, die in JEDEM Elternkontext gilt.
  const kasten = { width: size, height: size, minWidth: size, minHeight: size };

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={`rounded-full object-cover flex-shrink-0 border border-[var(--border-default,#E5E7EB)] ${className}`}
        style={kasten}
      />
    );
  }

  return (
    <div
      className={`rounded-full bg-[var(--bg-inset,#F8F9FC)] border border-[var(--border-default,#E5E7EB)] flex items-center justify-center flex-shrink-0 ${className}`}
      style={kasten}
    >
      <span
        className="font-bold text-[var(--text-secondary)]"
        style={{ fontSize }}
      >
        {initials}
      </span>
    </div>
  );
}
